/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateDeliverFeeKrGradeAmountReqVo } from './CreateUpdateDeliverFeeKrGradeAmountReqVo';
import {
    CreateUpdateDeliverFeeKrGradeAmountReqVoFromJSON,
    CreateUpdateDeliverFeeKrGradeAmountReqVoFromJSONTyped,
    CreateUpdateDeliverFeeKrGradeAmountReqVoToJSON,
    CreateUpdateDeliverFeeKrGradeAmountReqVoToJSONTyped,
} from './CreateUpdateDeliverFeeKrGradeAmountReqVo';

/**
 * 
 * @export
 * @interface CreateUpdateDeliverFeeKrReqVo
 */
export interface CreateUpdateDeliverFeeKrReqVo {
    /**
     * 仓库id
     * @type {number}
     * @memberof CreateUpdateDeliverFeeKrReqVo
     */
    warehouseId: number;
    /**
     * 运输方式
     * @type {number}
     * @memberof CreateUpdateDeliverFeeKrReqVo
     */
    transportMethodId?: number;
    /**
     * 韩国国内运费分组：1橙火服务，2韩国3PL出库
     * @type {number}
     * @memberof CreateUpdateDeliverFeeKrReqVo
     */
    orderTypeGroup: number;
    /**
     * 起始值 重量 单位kg
     * @type {number}
     * @memberof CreateUpdateDeliverFeeKrReqVo
     */
    beginValueKg?: number;
    /**
     * 结束值 重量 单位kg
     * @type {number}
     * @memberof CreateUpdateDeliverFeeKrReqVo
     */
    endValueKg?: number;
    /**
     * 起始值  三边合 单位cm
     * @type {number}
     * @memberof CreateUpdateDeliverFeeKrReqVo
     */
    beginValueCm?: number;
    /**
     * 结束值  三边合 单位cm
     * @type {number}
     * @memberof CreateUpdateDeliverFeeKrReqVo
     */
    endValueCm?: number;
    /**
     * 等级金额
     * @type {Array<CreateUpdateDeliverFeeKrGradeAmountReqVo>}
     * @memberof CreateUpdateDeliverFeeKrReqVo
     */
    gradeAmounts: Array<CreateUpdateDeliverFeeKrGradeAmountReqVo>;
}

/**
 * Check if a given object implements the CreateUpdateDeliverFeeKrReqVo interface.
 */
export function instanceOfCreateUpdateDeliverFeeKrReqVo(value: object): value is CreateUpdateDeliverFeeKrReqVo {
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('orderTypeGroup' in value) || value['orderTypeGroup'] === undefined) return false;
    if (!('gradeAmounts' in value) || value['gradeAmounts'] === undefined) return false;
    return true;
}

export function CreateUpdateDeliverFeeKrReqVoFromJSON(json: any): CreateUpdateDeliverFeeKrReqVo {
    return CreateUpdateDeliverFeeKrReqVoFromJSONTyped(json, false);
}

export function CreateUpdateDeliverFeeKrReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateDeliverFeeKrReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'],
        'transportMethodId': json['transportMethodId'] == null ? undefined : json['transportMethodId'],
        'orderTypeGroup': json['orderTypeGroup'],
        'beginValueKg': json['beginValueKg'] == null ? undefined : json['beginValueKg'],
        'endValueKg': json['endValueKg'] == null ? undefined : json['endValueKg'],
        'beginValueCm': json['beginValueCm'] == null ? undefined : json['beginValueCm'],
        'endValueCm': json['endValueCm'] == null ? undefined : json['endValueCm'],
        'gradeAmounts': ((json['gradeAmounts'] as Array<any>).map(CreateUpdateDeliverFeeKrGradeAmountReqVoFromJSON)),
    };
}

export function CreateUpdateDeliverFeeKrReqVoToJSON(json: any): CreateUpdateDeliverFeeKrReqVo {
    return CreateUpdateDeliverFeeKrReqVoToJSONTyped(json, false);
}

export function CreateUpdateDeliverFeeKrReqVoToJSONTyped(value?: CreateUpdateDeliverFeeKrReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'transportMethodId': value['transportMethodId'],
        'orderTypeGroup': value['orderTypeGroup'],
        'beginValueKg': value['beginValueKg'],
        'endValueKg': value['endValueKg'],
        'beginValueCm': value['beginValueCm'],
        'endValueCm': value['endValueCm'],
        'gradeAmounts': ((value['gradeAmounts'] as Array<any>).map(CreateUpdateDeliverFeeKrGradeAmountReqVoToJSON)),
    };
}

